import * as React from 'react';
import Typography from '@mui/material/Typography';

export default function Dashboard() {
    // return <Typography>Dashboard</Typography>;
    return (<></>)
}